import moment from 'moment'
import { API_DATE_FORMAT, VUETIFY_DATE_FORMAT } from '@/const'

const INCIDENCIAS_CATALOG = [1, 2, 3, 4, 5]
const INCIDENCIAS_CALCULABLES = [3, 4, 5]
const INCIDENCIA_FALTA = {
  3: 6,
  4: 3,
  5: 2,
}

function getFaltasAdministrativasAplicables(faltasAdministrativas, fechaAplicacionEvaluacion) {
  return faltasAdministrativas.filter((falta) => {
    return moment(falta.fechaDesde, API_DATE_FORMAT).isBetween(
      moment(fechaAplicacionEvaluacion, VUETIFY_DATE_FORMAT).subtract(3, 'year'),
      moment(fechaAplicacionEvaluacion, VUETIFY_DATE_FORMAT)
    )
  })
}

export function getIncidencias(faltasAdministrativas, fechaAplicacionEvaluacion) {
  const incidencias = []
  const faltasAplicables = getFaltasAdministrativasAplicables(faltasAdministrativas, fechaAplicacionEvaluacion)

  INCIDENCIAS_CATALOG.forEach((incidencia) => {
    if (INCIDENCIAS_CALCULABLES.includes(incidencia)) {
      incidencias.push({
        cantidad: faltasAplicables.filter((falta) => falta.fk_idTipoFalta === INCIDENCIA_FALTA[incidencia]).length,
        idIncidencia: incidencia,
      })
    } else {
      incidencias.push({
        cantidad: 0,
        idIncidencia: incidencia,
      })
    }
  })

  return incidencias
}
